import { Spinner } from '@tempmee/react';
import React from 'react';

export const ContentLayout = ({ isLoading, children }) => {
  if (isLoading) {
    return (
      <div style={{ height: '100%' }}>
        <Spinner centered variant="default" size="md" />
      </div>
    );
  }

  return (
    <div
      data-cy="forgot-password-reset-container"
      style={{
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        marginBottom: 120,
        height: '100%',
      }}
    >
      {children}
    </div>
  );
};
